import { createSlice } from "@reduxjs/toolkit"
import {
  addCity,
  deleteCity,
  getAllCities,
  getAllCityList,
  getCityDetails,
  updateCity,
  updateCityStatus,
} from "store/actions/cityAction"
import { getAllRegionList } from "store/actions/regionAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  cities: [],
  cityList: [],
  cityDetails: {},
}

const usersSlice = createSlice({
  name: "city",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL COUNTRIES
    builder

      .addCase(getAllCityList.pending, state => {})
      .addCase(getAllCityList.fulfilled, (state, action) => {
        const { status, data } = action.payload
        if (status) {
          state.cityList = data
        }
      })
      .addCase(getAllCityList.rejected, (state, action) => {})

      .addCase(getAllCities.pending, state => {
        state.loading = true
      })
      .addCase(getAllCities.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.cities = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllCities.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE CITY STATUS
    builder
      .addCase(updateCityStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateCityStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.cities = state.cities.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateCityStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD CITY
    builder
      .addCase(addCity.pending, state => {
        state.isLoading = true
      })
      .addCase(addCity.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addCity.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET CITY DETAILS
    builder
      .addCase(getCityDetails.pending, state => {
        state.loading = true
        state.cityDetails = {}
      })
      .addCase(getCityDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.cityDetails = data
        }
      })
      .addCase(getCityDetails.rejected, (state, action) => {
        state.loading = false
      })

    //  UPDATE CITY
    builder
      .addCase(updateCity.pending, state => {
        state.isLoading = true
        state.cityDetails = {}
      })
      .addCase(updateCity.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateCity.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE CITY
    builder
      .addCase(deleteCity.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteCity.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.cities = state.cities.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteCity.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
